// Copyright (c) 2022 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {saveBaseMachineImplements} from '../../shared/repositories';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';
import {updateImplements} from './implements';

export const updatePurchaseOrder = value =>

    dispatch => {

        dispatch({
            type: actions.UPDATE_PRODUCT_DETAILS_PURCHASE_ORDER,
            value
        });

    };

export const addFile = file => ({
    file,
    type: actions.UPDATE_BASE_MACHINE_IMPLEMENTS_FILE
});

export const addComponents = () => ({
    type: actions.CREATE_PRODUCT_DETAILS_COMPONENTS
});

export const deleteComponents = index => ({
    index,
    type: actions.DELETE_PRODUCT_DETAILS_COMPONENTS
});

export const updateBaseMachineComponents = (index, value) => ({
    index,
    type: actions.UPDATE_PRODUCT_DETAILS_COMPONENTS,
    value
});

export const updateBaseMachineImplements = (baseMachineComponents, pin) =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await saveBaseMachineImplements(baseMachineComponents, pin);

            successAlertBar(translate('COMPONENT_SUCCESSFULLY_UPDATED'));

            updateImplements(pin)(dispatch);

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/details/action-creators/base-machine-implements.js